(function () {
    'use strict';

    angular
        .module('FormBuilder')
        .directive('fbFieldFile', fbFieldFileDirective);

    function fbFieldFileDirective() {
        return {
            restrict: 'E',
            scope: {
                element: '=',
                model: '='
            },
            templateUrl: 'common/components/file-upload',
            controller: fbFieldFileDirectiveCtrl,
            link: fbFieldFileDirectiveLink,
            controllerAs: 'vm',
            bindToController: true
        };

        function fbFieldFileDirectiveLink(scope, elem) {
            var em = elem.find('em');
            elem.remove('em');
            elem.find('.k-dropzone').prepend(em);
        }
    }

    function fbFieldFileDirectiveCtrl($scope, $element, lodash, FormBuilderService, CommonHelper) {
        var vm = this;
        var formIdentifier = '';

        this.$onInit = function () {
            formIdentifier = $scope.$parent.vm.formIdentifier;

            FormBuilderService.sync(formIdentifier, vm);
            vm.onEventTrigger = vm.pageData.eventsService.onEventTrigger.bind(vm);

            vm.onLoadEventOptions = vm.pageData.eventsService.getEventOptions(vm.element.elementIdentifier, 'onLoad');
            console.log(vm.element.options);
            initEventOptions();
            var files = lodash.get(vm, 'model', []);
            if (lodash.isEmpty(files)) {
                files = [];
            } else {
                if (!Array.isArray(files)) {
                    files = [files];
                }
            }
            // added this to provide backward compatibility with other places other than application
            files = files.map(function (file) {
                if (!lodash.has(file, 'name')) {
                    if (lodash.has(file, 'file_name'))
                        file.name = file.file_name;
                }
                if (!lodash.has(file, 'extension')) {
                    if (lodash.has(file, 'file_ext'))
                        file.extension = file.file_ext;
                }
                return file;
            });
            vm.upload_options = {
                multiple: lodash.get(vm.onLoadEventOptions, 'multiple', false),
                async: lodash.get(vm.onLoadEventOptions, 'async', {}),
                upload: uploadEvent,
                remove: removeEvent,
                success: successEvent,
                error: errorEvent,
                files: files,
                localization: lodash.get(vm.element, 'options.localization', {})
            };
            console.log(vm.upload_options);
        }

        function initEventOptions() {
            if (lodash.has(vm.onLoadEventOptions, 'async')) {
                const formDraftId = lodash.get(vm.pageData, 'model.hid_form_draft_id', '');
                vm.onLoadEventOptions.async.removeUrl = decodeURI(vm.onLoadEventOptions.async.removeUrlTemplate).replace(new RegExp('<id>', 'g'), formDraftId);
                if (lodash.has(vm.onLoadEventOptions.async, 'saveUrlTemplate')) {
                    vm.onLoadEventOptions.async.saveUrl = decodeURI(vm.onLoadEventOptions.async.saveUrlTemplate).replace(new RegExp('<id>', 'g'), formDraftId);
                }
            }
        }


        function uploadEvent(e) {
            if (lodash.has(vm.onLoadEventOptions, 'fileSize')) {
                if (e.files[0].size > vm.onLoadEventOptions.fileSize) {
                    // var wrapper = $element.parents('label');
                    //
                    // wrapper.addClass('error');
                    // var msg = lodash.get(vm, 'element.validation.fileSize', 'File should not be greater than 2 MB');
                    // wrapper.find('.error-message-wrapper').html("<div class='error-message'>" + msg + "</div>");
                    e.preventDefault();

                    var sizing = CommonHelper.bytesToSize(vm.onLoadEventOptions.fileSize);
                    var limitFileMessage = lodash.get(vm, 'element.options.limitFileMessage', 'File should not be greater than');
                    vm.pageData.elementsService.setValidationError(vm.element.elementIdentifier, [lodash.get(vm, 'element.validation.fileSize', limitFileMessage+' '+sizing)], true);
                    $scope.$apply();
                    return false;
                }
            }

            if (lodash.has(vm.element, 'attr.sender_name')) {
                e.sender.name = vm.element.attr.sender_name;
            }
            e.data = lodash.get(vm, 'element.attr.upload_data', {});
        }


        function removeEvent(e) {
            e.sender.options.async.removeUrl = vm.onLoadEventOptions.async.removeUrl + e.files[0].file_id;
        }

        function successEvent(e) {
            switch (e.operation) {
                case "upload":
                    e.files[0].name = e.response.data.file_name;
                    e.files[0].extension = e.response.data.file_ext;
                    e.files[0].file_id = e.response.data.file_id;
                    var file_elem = $element.find('.k-file[data-uid="' + e.files[0].uid + '"] .k-filename');
                    file_elem.attr('title', e.response.data.file_name);
                    file_elem.html(e.response.data.file_name);

                    if (lodash.get(vm.element, 'options.multiple', false)) {
                        vm.model.push(e.response.data);
                    } else {
                        // vm.model = e.response.data;
                        // angular.extend(vm.model, e.response.data);
                        Object.assign(vm.model, e.response.data);
                    }

                    vm.pageData.elementsService.clearElementValidationRule(vm.element.elementIdentifier);
                    // $element.parents('.error').removeClass('error').find('.error-message').remove();
                    vm.onEventTrigger('onUploadSuccess');
                    break;
                case "remove":
                    // vm.model.forEach(function(value, key) {
                    //     delete vm.model[key];
                    // });

                    for (var propertyKey in vm.model) {
                        if (vm.model.hasOwnProperty(propertyKey)) {
                            delete vm.model[propertyKey];
                        }
                    }
                    break;
            }
        }

        function errorEvent(e) {
            //console.log(e);
            if (e.XMLHttpRequest.status == 422) {

                var rules = JSON.parse(e.XMLHttpRequest.response);
                vm.pageData.elementsService.setValidationError(vm.element.elementIdentifier, lodash.get(rules.rules, vm.element.elementIdentifier, []));
                // vm.pageData.elementsService.setValidationError(vm.element.elementIdentifier, rules.rules[vm.element.name]);
                $scope.$apply();
            }
            vm.onEventTrigger('onUploadFailure');
        }
    }
})();